import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {getYcLogoFile} from '../../../../../utils/entity/file';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, membership, payment, program, refund} = contexts;

  const data: EventData = {};

  if (payment) {
    if (payment.type === 'subscription') {
      data.avatar = getYcLogoFile(180);
      data.avatarPlaceholder = 'Your Coach';

      data.title =
        /**
         * @i18n_parser
         *
         * t('notifications:payment_successful.subscription.title')
         * t('notifications:payment_reversed.subscription.title')
         */
        i18n.t(`notifications:${event.type}.subscription.title`, {
          price: getPriceString({
            currency: Currency[payment.currency],
            price: refund ? refund.amount : payment.amount,
          }),
        });
    } else {
      const courseLabel = getCourseLabel(course);

      data.avatar = program?.avatar;
      data.avatarPlaceholder = program?.title;

      data.title =
        /**
         * @i18n_parser
         *
         * t('notifications:payment_successful.program.title')
         * t('notifications:payment_reversed.program.title')
         * t('notifications:payment_successful.refund.title')
         * t('notifications:payment_reversed.refund.title')
         */
        i18n.t(`notifications:${event.type}.${payment.type}.title`, {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: program?.title,
          price: getPriceString({
            currency: Currency[payment.currency],
            price: refund ? refund.amount : payment.amount,
          }),
          userName: membership ? membership.user_name : '',
        });
    }
  }

  data.icon = CheckIcon;
  data.iconGradient = 'success';

  return data;
};
